import { render, staticRenderFns } from "./P_tigercenter.vue?vue&type=template&id=61f75b42&scoped=true&"
import script from "./P_tigercenter.vue?vue&type=script&lang=js&"
export * from "./P_tigercenter.vue?vue&type=script&lang=js&"
import style0 from "./P_tigercenter.vue?vue&type=style&index=0&id=61f75b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f75b42",
  null
  
)

export default component.exports